import { render, staticRenderFns } from "./goodsSpec.vue?vue&type=template&id=6d65ff11&scoped=true&"
import script from "./goodsSpec.vue?vue&type=script&lang=js&"
export * from "./goodsSpec.vue?vue&type=script&lang=js&"
import style0 from "./goodsSpec.vue?vue&type=style&index=0&id=6d65ff11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65ff11",
  null
  
)

export default component.exports